import { render, staticRenderFns } from "./QAQC.vue?vue&type=template&id=0c9ae369"
import script from "./QAQC.vue?vue&type=script&lang=ts"
export * from "./QAQC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports